// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1SVSx","colCheckbox":"styles_colCheckbox__3nM4S"};